import { useState, useRef } from "react";
import Config from "../../Config";

import InputText from "../../helpers/InputText";

import edit from "../../edit.png";
import trash from "../../trash.png";
import cal from "../../cal.png";
import calw from "../../calw.png";
import goclose2 from "../../goclose2.png";
import zoom from "../../zoom.png";

import PlTitle from "../../elements/PlTitle";
import InputPagger from "../../helpers/InputPagger";

 
//import KidNew from "./KidNew";
//import GroupEdit from "./GroupEdit";

import icoArrow from '../../Down_Arrow_3_.png'
import gochat from "../../gochat.png";


import InputTextAlpha from "../../helpers/InputTextAlpha";
import InputCombo from "../../helpers/InputCombo";
import InputLegend from "../../helpers/InputLegend";
import InputComboGrupa from "../../helpers/InputComboGrupaE";
import KidShow from "./KidShow.js";
import KidShowM from "./KidShowM.js";
//import KidDelete from "./KidDelete";
//import KidsMove from "./KidsMove";

//import Start from "./Start";
import QuickChat from "../msgE/QuickChat";
import SortBy from "../../helpers/SortBy";
import MenuTable from "../../helpers/MenuTable";
//import KidDeleteMass from "./KidDeleteMass";


function Kids(props)
{
    //do przemyślenia
    var cData = Config.getFromBuffer(Config.cache_grups_emps,3600, props.userData );
    
    const [gr, setGr] = useState(cData);

    const [refreshView, setRefreshView] = useState(props.userData.refreshView);


    const [filter, setFilter] = useState(null);
    const [filterParam, setFilterParam] = useState({   
        d_imie_nazwisko:  props.mainView.readFilter('d_imie_nazwisko',''),
        r_imie_nazwisko:  props.mainView.readFilter('r_imie_nazwisko',''), 
        p_grupa_id: '_x_',
        archiwalne: '0',

        sortBy: {
            sort:  "", //asc desc,
            column: "",
        },


        limit: 50,
        page: 1,
        pages: 1,
    });
    const [tab, setTab] = useState(null);
    const [selectedRow, setSelectedRow] = useState([]);

    
    const [optionTakNie, setOptionTakNie]  = useState([
        {
            v: '_x_',
            title: ' - - - '
        },
        {
            v: '0',
            title: 'Nie'
        }, {
            v: '1',
            title: 'Tak'
        }
    ]
    );
    
    const tabRef = useRef(0); //do druku

    

    

    var defView =  {
        v:'list',
        id: -1
    } ;

    if(props.mainView.idSelected == -2)
    {
        defView =  {
            v:'new',
            id: -1
        } ;
    }

    const [view, setView] = useState ( defView);

    const [legend, setLegend] = useState([
        {
            cls:'color_deleted',
            title: 'dziecko przeniesione do archiwum',
            filter: {  filed: "archiwalne", set: "1", typ: "combo"  },
        },
    ]);

    const getGr = () => {
       
 
        props.mainView.setProgress(-2);
    
       
    
        fetch( Config.url + '/rest_v1_employessModule,gr', {
            method: 'POST', 
            body: JSON.stringify({}), 
            headers: {
                'Content-Type': 'application/json',                    
                'X-Api-Key': props.userData.apiKey,
                '_p_przedszkole_id_': props.userData.p_przedszkole_id,
                '_p_dziecko_id_': props.userData.p_dziecko_id,
                '_sec_key_': Config.genXKey() ,
            }
         })
         .then(res => res.json() )
         .then(res => { 
    
                    props.mainView.setProgress(-1);        
                    if(res._sys_ == undefined)
                    {
                        props.mainView.showDialog( "Error", "No correct response from server" , "ok" , null);  
                    }else
                    if(res.status != undefined && res.status == 'ERROR'  && res.result != undefined )
                    {
                        props.mainView.showDialog( "Error", JSON.stringify(res.result) , "ok" , null);  
                    }else    
                    {
                        setGr(res.result);      
                        
                        Config.setToBuffer(Config.cache_grups, res.result, props.userData);
                                
                    }
    
            } )
            .catch(err => {          
                    props.mainView.showDialog( "Error", "I: " + err , "ok" , null);
                    props.mainView.setProgress(-1);
            });
                   
    
            return false;
    }

    

    

    if( gr == null ||  gr.length == 0 )
    {
            getGr();
            
            return <div></div>;                 
            
    }





    const getTab = () => {
       
 
        props.mainView.setProgress(-2);

       

        fetch( Config.url + '/rest_v1_employessModule,kidsE_kids', {
            method: 'POST', 
            body: JSON.stringify(filterParam), 
            headers: {
                'Content-Type': 'application/json',                    
                'X-Api-Key': props.userData.apiKey,
                '_p_przedszkole_id_': props.userData.p_przedszkole_id,
                '_p_dziecko_id_': props.userData.p_dziecko_id,
                '_sec_key_': Config.genXKey() ,
            }
         })
         .then(res => res.json() )
         .then(res => { 

                    props.mainView.setProgress(-1);        
                    if(res._sys_ == undefined)
                    {
                        props.mainView.showDialog( "Error", "No correct response from server" , "ok" , null);  
                    }else
                    if(res.status != undefined && res.status == 'ERROR'  && res.result != undefined )
                    {
                        props.mainView.showDialog( "Error", JSON.stringify(res.result) , "ok" , null);  
                    }else    
                    {
                        setTab(res.result);            


                        var newSelector = [];

                        res.result.forEach( (item) => {
                            newSelector.push({
                                id: item.id,
                                title: item.imie  + "  " + item.nazwisko,
                                selected: 0,
                            });
                        } )

                        setSelectedRow(newSelector);


                        if(res.pages != undefined )setFilterParam( {...filterParam,   ['pages']: res.pages  } );             
                    }
         } )
         .catch(err => {          
                    props.mainView.showDialog( "Error", "I: " + err , "ok" , null);
                    props.mainView.setProgress(-1);
         });
                   

         return false;
    }

  

    const valChangeListener = (filedName, val, correct, msg) => {

        //console.log("valChangeListener: " + filedName + " " + val + ", correct: " + correct + ", msg: " + msg);

        setFilterParam( {...filterParam, [filedName]:val,  [filedName+"_valid"]:correct } );
        
        
        var modX = val.length % 3;
        if(  val.length == 0 || modX == 0 || msg =='combo')
        setTab(null);  

        props.mainView.writeFilter(filedName, val);
    }


    const goNextNew = () => {
        //console.log("goNext");    
        setTab(null);    
    }

    const filterClear = () => {

        props.mainView.writeFilter('d_imie_nazwisko', '');
        props.mainView.writeFilter('r_imie_nazwisko', '');
        props.mainView.writeFilter('p_group_id', '_x_');
        props.mainView.writeFilter('archiwalne', '0');

        setFilterParam({ 
            d_imie_nazwisko: '', 
            r_imie_nazwisko: '',
            p_grupa_id: '_x_',
            archiwalne: 0,    
            
            sortBy: {
                sort:  "", //asc desc,
                column: "",
            },


            limit: 50,
            page: 1,
        });
        setTab(null);
    }

    const filterApprove = () => {   
        setTab(null)     
    }

    const onChangePagger = (x_limit, x_page) => {

        setFilterParam(  {...filterParam, ["limit"]:x_limit, ["page"]:x_page} );
        setTab(null);
    }

    const onChangeSortBy = (sortBy) => {

        setFilterParam(  {...filterParam, ["sortBy"]:sortBy } );
        setTab(null);
    }


    if(tab == null)
    {
        setTab([]);
        getTab();
     

        return <div>
            ...
        </div>
    }


    if(refreshView != props.userData.refreshView)
    {         
        setRefreshView( props.userData.refreshView);
        setTab(null);
        setView( {
            v:'list',
            id: -1
        });
    }


    
    const changeView = (e ) => {
            var v = e.target.getAttribute('v');
            var id = e.target.getAttribute('id');

            setView({...view, ["v"]:v, ["id"]:id });
    }


    const onBack = ( ) => {                
        setView({...view, ["v"]:"list", ["id"]:-1 });       
        getTab();
    }




    var sortList = [                
        {column: "created_at", name: "Data utworzenia"  },         
        {column: "dziecko_nazwisko", name: "Nazwisko"  },
]

 

    var xwindow = null;

    var is_mobile = props.mainView.isMobile();

    if(view.v == 'show')
    {
        var searchRow = null;
        for(var k=0; k<tab.length; k++)
        {
            if(tab[k].id == view.id) { 
                searchRow = tab[k]; break; }
        }
    
        

        if(is_mobile)
            return <KidShowM  userData={props.userData} mainView={props.mainView} row={searchRow} onBack={onBack}    />
        else
            return <KidShow grupy={gr} userData={props.userData} mainView={props.mainView}  row={searchRow} onBack={onBack}    />    
    }


        var zaznaczonych = 0;
        for(var s=0; s<selectedRow.length; s++)
        {
            if(selectedRow[s].selected == 1) zaznaczonych ++;
        }

    

    var table = '';    
   
    if(is_mobile)
    {   

        table = gr.map( (grupa, ix) => {

                var grupa_dzieci = tab.filter(tab => tab.grupa === grupa.title)

                

                if(grupa.v!='_x_')

                if(filterParam.p_grupa_id=='_x_' || filterParam.p_grupa_id==grupa.v)    
                {
                    return <div className='mobile_table'>
                    <div className="mobile_th">{grupa.title} ({grupa_dzieci.length})</div>
                        <div className="mobile_tb">
                        {
                            grupa_dzieci.map( (dziecko, ix2) => {

                                return <div className='kid_row'>
                                    <div className='kid_row_cell item_5' onClick={changeView} v="show" id={dziecko.id}>{ix2+1}</div>
                                    <div className='kid_row_cell item_80' onClick={changeView} v="show" id={dziecko.id}>{dziecko.imie} {dziecko.nazwisko}</div>
                                    <div className='kid_row_cell link_normal item_5'><img onClick={changeView} v="show" id={dziecko.id} src={zoom}></img></div>
                                </div>
                            })
                        }    
                        </div>
                    </div>
                }
                
                

            }
        )

        
    }
    else
    {
        table = (<div>

            <div className="table_widget">
                <InputPagger filter={filterParam}  onChange={onChangePagger}  />
                <InputLegend items={legend}  valChange={valChangeListener} />
                <SortBy  cols={sortList} param={filterParam.sortBy}  onChange={onChangeSortBy}  />  
            </div>

            <table className="table" ref={tabRef}>
                                        <thead>
                                            <tr className="header">
                                                <td className="td_left">LP</td>
                                                
                                                <td>Grupa</td>  
                                                <td>Nazwisko, imię</td>    
                                                <td>Rodzice</td>  
                                                <td className="td_right">Osoby upoważnione</td>                                       
                                                <td className="td_option"> </td>
                                                
                                          
                                              
                                            </tr>
                                        </thead>
                                        <tbody>

                                            {
                                                tab.map( (row, ix) => {

                                                    var cls = "";
                                                    if(row.archiwalne == '1') cls = "color_deleted";


                                                    var isChecked = "";

                                                    for(var s=0; s<selectedRow.length; s++)
                                                        {
                                                            if( selectedRow[s].id == row.id &&  selectedRow[s].selected == 1) isChecked = "checked";
                                                        }

                                                        var rowStyle = " row ";
                                                        if(ix % 2 == 0 )rowStyle = " row2 ";

                                                    return (
                                                        <tr className={rowStyle + cls}  key={ix+"r"} > 

                                                            <td className="gocenter">{ix+1}</td>
                                                            
                                                            <td className="link_normal"  onClick={changeView} v="show" id={row.id}>{row.grupa}</td>
                                                            <td  onClick={changeView} v="show" id={row.id} className="link_normal">{row.nazwisko + " " + row.imie  }</td>
                                                            <td  className="link_normal" >
                                                                { 
                                                                    row.rodzice.map( (rodz, rI) => {

                                                                        var img = <span>{rodz.imie} {rodz.nazwisko} <img src={gochat} title="Rozpocznij chat"  className="link_normal img_small" /></span>;

                                                                        return <span>
                                                                               <QuickChat id={rodz.id}  title={rodz.imie +" " + rodz.nazwisko } name={img} mainView={props.mainView} userData={props.userData} /> 
                                                                               
                                                                        </span>
                                                                    } )
                                                                }
                                                            </td>
                                                            <td>
                                                                { 
                                                                    row.osoby_upowaznione.map( (osb, rI) => {
                                                                        
                                                                        if(osb.id>0)
                                                                        {
                                                                            return <span>
                                                                                {    osb.nazwisko + " " + osb.imie + " ("+osb.stopien_pokrewienstwa+" | "+osb.nr_dowodu_4_ost_znaki+")" +", "}
                                                                              
                                                                            </span>
                                                                        }
                                                                        
                                                                        
                                                                    } )
                                                                }
                                                            </td>
                                                           
                                                    
                             
                                                            <MenuTable>
                                                                        <ul>
                                                                            <li  onClick={changeView} v="show" id={row.id}  >szczegoły</li>
                                                                        </ul>                                                               
                                                            </MenuTable>  

                                                        </tr>  
                                                    )
                                                } )
                                            }

                                        </tbody>
                                </table>
        </div>)   
    }    

    return (

        <div className="view_content">

            {xwindow}

           


            <div className="table_filter mobile_filters">
                            <div className="filter_controll">   
                                <label>Grupa: </label>                             
                                <InputComboGrupa   userData={props.userData}  mainView={props.mainView}  value={filterParam.p_grupa_id}   valChange={valChangeListener} goNext={goNextNew} name="p_grupa_id" placeholder={"Archiwalne: "}   />
                            </div> 

               
                           <div className="filter_controll">   
                                <label>Dziecko: </label>                             
                                <InputTextAlpha   userData={props.userData} value={filterParam.d_imie_nazwisko}   valChange={valChangeListener} goNext={goNextNew} name="d_imie_nazwisko" placeholder={"Dziecko: "}   />
                            </div>  
 
                            <div className="filter_controll">   
                                <label>Rodzic: </label>                             
                                <InputTextAlpha   userData={props.userData} value={filterParam.r_imie_nazwisko}   valChange={valChangeListener} goNext={goNextNew} name="r_imie_nazwisko" placeholder={"Rodzic: "}   />
                            </div> 


                          

                            <div className="filter_btn">
                                <span className="btn" onClick={filterApprove} >filtruj</span>&nbsp;&nbsp;<span className="btn" onClick={filterClear} >wyczyść</span>
                            </div>
                            
            </div>
            

            <div className="bg_center">
                    {table}        
            </div>


        </div>

    )

}

export default Kids;